import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.5 29.5H23.5C25.1569 29.5 26.5 28.1569 26.5 26.5V10.5V5.5C26.5 3.84315 25.1569 2.5 23.5 2.5H8.5C6.84315 2.5 5.5 3.84315 5.5 5.5V26.5C5.5 28.1569 6.84315 29.5 8.5 29.5Z"
            fill="#DEDEDE"
            stroke="#818181"
            strokeWidth="1.5"
        />
        <rect fill="#3C3C3C" height="10" rx="2" width="18" x="2" y="17" />
        <path
            d="M4 25.3413H9.00537V24.0449H5.90283V24.0142L8.90869 20.0239V19H4.04834V20.2964H7.01465V20.3271L4 24.3174V25.3413Z"
            fill="#FDFDFD"
        />
        <path d="M10.1279 25.3413H11.7407V19H10.1279V25.3413Z" fill="#FDFDFD" />
        <path
            d="M12.9731 25.3413H14.5859V23.4824H15.6757C17.0908 23.4824 18.0048 22.6123 18.0048 21.2544V21.2456C18.0048 19.8877 17.0908 19 15.6757 19H12.9731V25.3413ZM15.289 20.2349C15.9702 20.2349 16.3745 20.5864 16.3745 21.2456V21.2544C16.3745 21.9136 15.9702 22.2695 15.289 22.2695H14.5859V20.2349H15.289Z"
            fill="#FDFDFD"
        />
        <path
            d="M17.8922 5.53884L18.3039 3.48058C18.4179 2.91041 18.9185 2.5 19.5 2.5C20.0815 2.5 20.5821 2.91042 20.6961 3.48058L21.1078 5.53884C21.3107 6.55341 20.5347 7.5 19.5 7.5C18.4653 7.5 17.6893 6.55341 17.8922 5.53884Z"
            fill="#FDFDFD"
            stroke="#818181"
            strokeWidth="1.5"
        />
        <path
            d="M19.5 9.5V10.5"
            stroke="#818181"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
        <path
            d="M19.5 13.5V14.5"
            stroke="#818181"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
